import React, {useContext, useEffect} from 'react'
import client from '../images/photo2.jpg'
import { Carcontext } from '../context/carcontext'
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {checkClient} from "../redux/actions";
import Aos from 'aos'

const Clients = ({person}) => {

    const {t} = useTranslation()
    const dispatch = useDispatch()
    const loggedClient = useSelector(state => state.clients.isLoggedIn)

    const { OpenUserModal, theme } = useContext(Carcontext)

    useEffect(() => {
        Aos.init({})
    }, [])

    function logInAsThisUser(event, passportData) {
        event.stopPropagation()
        dispatch(checkClient(passportData))
    }

    return (
        <div className="animation" data-aos="zoom-out-up">
            <div className={`client ${person.in_black_list} ${theme}`} onClick={() => OpenUserModal(person)}>
                <div className="client-body">
                    <div className="client-imagebox">
                        <img src={!!person.photo ? `https://rezilizer.ru/${person.photo}` : client} alt="client: client" className="client-image" />
                    </div>
                    <div className="client-info">
                        <h3 className="client-surname">{person.lastname}</h3>
                        <h3 className="client-name">{person.firstname}</h3>
                        <div className="client-sensor">
                            <div className={`client-sensor-color ${person.status}`}></div>
                            <p className="client-sensor-value">{t(`${person.status}`)}</p>
                        </div>
                    </div>
                </div>
                <p className="client-number">{person.passport_series}</p>
                {
                    loggedClient ?
                        null :
                        <button className="userLogIn" onClick={event => logInAsThisUser(event, person.passport_series)}>
                            Log in
                        </button>
                }
            </div>
        </div>
    )
}

export default Clients
